import { render } from "./TariffFeature.vue?vue&type=template&id=726ab6f3&scoped=true"
import script from "./TariffFeature.vue?vue&type=script&lang=js"
export * from "./TariffFeature.vue?vue&type=script&lang=js"

import "./TariffFeature.vue?vue&type=style&index=0&id=726ab6f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726ab6f3"]])

export default __exports__